export { default } from './SkeletonFareCalendar';
